var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fst-LlmsSelect"},[_c('el-select',{attrs:{"value-key":"id"},on:{"change":_vm.handleChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }